import { render, staticRenderFns } from "./base-card.vue?vue&type=template&id=167b9e5f&scoped=true&"
import script from "./base-card.vue?vue&type=script&lang=js&"
export * from "./base-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b9e5f",
  null
  
)

export default component.exports